import React from "react";
import { InboxOutlined } from "@ant-design/icons";

const EmptyContent: React.FC<{
  message?: React.ReactNode;
}> = (props) => {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="flex items-center justify-center flex-col">
        <p className="p-4">
          <InboxOutlined style={{fontSize: "4rem"}} />
        </p>
        <p className="text-xl">{props.message ?? "Empty"}</p>
      </div>
    </div>
  );
};

export default EmptyContent;
